import styled from 'styled-components';
import { GEL_SPACING_TRPL } from '@bbc/gel-foundations/spacings';
var Figure =
/*#__PURE__*/
styled.figure.withConfig({
  displayName: "Figure",
  componentId: "sc-6a3dhy-0"
})(["margin:0;padding-bottom:", ";width:100%;"], GEL_SPACING_TRPL);
export default Figure;